/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuthnContextUpdateChallengeOptions } from './AuthnContextUpdateChallengeOptions';
import {
    AuthnContextUpdateChallengeOptionsFromJSON,
    AuthnContextUpdateChallengeOptionsFromJSONTyped,
    AuthnContextUpdateChallengeOptionsToJSON,
} from './AuthnContextUpdateChallengeOptions';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface AuthnContextUpdateChallenge
 */
export interface AuthnContextUpdateChallenge {
    /**
     * 
     * @type {string}
     * @memberof AuthnContextUpdateChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof AuthnContextUpdateChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof AuthnContextUpdateChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {AuthnContextUpdateChallengeOptions}
     * @memberof AuthnContextUpdateChallenge
     */
    options: AuthnContextUpdateChallengeOptions;
}

/**
 * Check if a given object implements the AuthnContextUpdateChallenge interface.
 */
export function instanceOfAuthnContextUpdateChallenge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

export function AuthnContextUpdateChallengeFromJSON(json: any): AuthnContextUpdateChallenge {
    return AuthnContextUpdateChallengeFromJSONTyped(json, false);
}

export function AuthnContextUpdateChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthnContextUpdateChallenge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': AuthnContextUpdateChallengeOptionsFromJSON(json['options']),
    };
}

export function AuthnContextUpdateChallengeToJSON(value?: AuthnContextUpdateChallenge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ChallengeTypeToJSON(value.type),
        'authentication_method': FactorMethodToJSON(value.authentication_method),
        'options': AuthnContextUpdateChallengeOptionsToJSON(value.options),
    };
}

